<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button (click)="closeModal()" text=""></ion-back-button>
    </ion-buttons>
    <ion-title>{{ticketSrv?.selectedTicket?.description}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [scrollEvents]="true" (ionScrollEnd)="contentScrollEvent.emit($event)">
  <div id="segment">
    <ion-segment mode="ios" id="contentSegment" [value]="mobileSegmentValue" (ionChange)="mobileSegmentChange($event)">
      <ion-segment-button layout="icon-start" value="messages">
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="message" class="svg-inline--fa fa-message" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M511.1 63.1v287.1c0 35.25-28.75 63.1-64 63.1h-144l-124.9 93.68c-7.875 5.75-19.12 .0497-19.12-9.7v-83.98h-96c-35.25 0-64-28.75-64-63.1V63.1c0-35.25 28.75-63.1 64-63.1h384C483.2 0 511.1 28.75 511.1 63.1z"></path></svg>
        <ion-label>Nachrichten</ion-label>
      </ion-segment-button>
      <ion-segment-button layout="icon-start" value="details">
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" class="svg-inline--fa fa-circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"></path></svg>
        <ion-label>Details</ion-label>
      </ion-segment-button>
    </ion-segment>
  </div>
  <div *ngIf="mobileSegmentValue == 'messages'" style="margin-top: 20px;">
    <cu-main [contentScrollEvent]="contentScrollEvent"></cu-main>
  </div>
  <cu-details *ngIf="mobileSegmentValue == 'details'"></cu-details>
</ion-content>
